import { TransactionType } from "../../types/enums/TransactionType";
import { identity } from "lodash";

import { TMessage } from "../../i18n/tt";
import { RadioFieldModel } from "../../common/commonForms";

export type ReductionTransaction =
  | TransactionType.CANCELLATION_OF_SHARES
  | TransactionType.REDUCTION_NOMINAL_VALUE;

export enum Purpose {
  COVER_OF_LOSS = "COVER_OF_LOSS",
  DISTRIBUTION = "DISTRIBUTION_TO_SHAREHOLDERS",
  CANCELLATION_OF_OWN = "CANCELLATION_OWN_SHARES",
  TRANSFER = "TRANSFER_OTHER_EQUITY",
}

export const purposeCaptions: { [key in Purpose]: TMessage } = {
  [Purpose.COVER_OF_LOSS]: { key: "transactions.capitalReduction.purposeLabels.COVER_OF_LOSS" },
  [Purpose.DISTRIBUTION]: {
    key: "transactions.capitalReduction.purposeLabels.DISTRIBUTION_TO_SHAREHOLDERS",
  },
  [Purpose.CANCELLATION_OF_OWN]: {
    key: "transactions.capitalReduction.purposeLabels.CANCELLATION_OWN_SHARES",
  },
  [Purpose.TRANSFER]: { key: "transactions.capitalReduction.purposeLabels.TRANSFER_OTHER_EQUITY" },
};

export function createPurposeModel({
  transactionType,
  onChange,
}: {
  transactionType: ReductionTransaction;
  onChange: (option: Purpose | undefined) => void;
}) {
  return new RadioFieldModel<Purpose | undefined>({
    required: true,
    options: purposeOptions(transactionType),
    value: undefined,
    idFn: identity,
    labelFn: (value) => (value ? purposeCaptions[value] : { translated: "" }),
    onChange,
  });
}

export function purposeOptions(transactionType: ReductionTransaction): Purpose[] {
  const options = Object.values(Purpose);
  return transactionType === TransactionType.CANCELLATION_OF_SHARES
    ? options
    : options.filter((purpose) => purpose !== Purpose.CANCELLATION_OF_OWN);
}
